/**
 * Choix du thème, conservé sur l'appareil.
 *
 * Trois états et non deux : « système » suit le réglage du téléphone, ce qui est le comportement
 * attendu par défaut et le seul qui basculera tout seul le soir. « clair » et « sombre » sont des
 * choix explicites qui l'emportent.
 *
 * Stocké dans le navigateur et non en base, délibérément : on peut vouloir le sombre sur son
 * téléphone au lit et le clair sur l'ordinateur en journée. Un réglage de compte imposerait le
 * même aux deux.
 */
export type Theme = 'clair' | 'sombre' | 'systeme'

const CLE = 'organisateur.theme'

export function lireTheme(): Theme {
  try {
    const valeur = localStorage.getItem(CLE)
    return valeur === 'clair' || valeur === 'sombre' ? valeur : 'systeme'
  } catch {
    // Navigation privée stricte : le stockage peut lever. On retombe sur le réglage système,
    // qui ne demande rien à personne.
    return 'systeme'
  }
}

/**
 * Pose ou retire l'attribut lu par `theme.css`. En « système », aucun attribut n'est posé :
 * c'est la requête de média qui décide, sans JavaScript — donc sans clignotement au chargement.
 */
export function appliquerTheme(theme: Theme) {
  const racine = document.documentElement

  if (theme === 'systeme') {
    racine.removeAttribute('data-theme')
  } else {
    racine.setAttribute('data-theme', theme === 'sombre' ? 'dark' : 'light')
  }
}

export function enregistrerTheme(theme: Theme) {
  try {
    if (theme === 'systeme') {
      localStorage.removeItem(CLE)
    } else {
      localStorage.setItem(CLE, theme)
    }
  } catch {
    // Sans stockage, le choix ne survit pas au rechargement. C'est une dégradation acceptable :
    // l'application reste utilisable, elle repart simplement du réglage système.
  }

  appliquerTheme(theme)
}
